"use strict";

// key : string | [ string, null, function | object ] | function | object
// string : '*' | !value | value 
// object : { not : [ ], and : }
function doesValueMatch(value, cxtValue, cxt) {
  if (Array.isArray(value)) {
    for (let n = 0; n < value.length; n++) {
      if (doesValueMatch(value[n], cxtValue, cxt)) {
        return true;
      }
    }

    return false;
  } // eslint-disable-next-line eqeqeq


  if (value == cxtValue) {
    return true; // handles string, number, null equality
  }

  if (Array.isArray(cxtValue)) {
    for (let i = 0; i < cxtValue.length; i++) {
      if (doesValueMatch(value, cxtValue[i], cxt)) {
        return true;
      }
    }
  }

  const t = typeof value;

  if (t === 'string') {
    if (value === '*') {
      return cxtValue != null; // any value will do
    }

    if (value[0] === '!') {
      // eslint-disable-next-line eqeqeq
      return value.substring(1) != cxtValue;
    }

    if (value[0] === '>') {
      if (value[1] === '=') {
        return cxtValue >= value.substring(2);
      }

      return cxtValue > value.substring(1);
    }

    if (value[0] === '<') {
      if (value[1] === '=') {
        return cxtValue <= value.substring(2);
      }

      return cxtValue < value.substring(1);
    }

    return false; // equality handeled above
  }

  if (t === 'object') {
    if (value == null) {
      return cxtValue == null;
    }

    if (value.not && doesValueMatch(value.not, cxtValue, cxt)) {
      return false;
    }

    return value.and ? doesValueMatch(value.and, cxtValue, cxt) : true;
  }

  if (t === 'function') {
    return value(cxt, cxtValue);
  }

  return false;
}
/**
 * This will determine whether or not the context satisfies
 * the matches object.
 * @param {object} context the context
 * @param {object|function|array} matches the object or function used to
 * determine the matches state. If this is an array, it is an array of 
 * object/functions and this function will return true if any one of the
 * objects/functions match
 */


function isMatch(cxt, matches) {
  // No match criteria
  if (matches == null) {
    return true;
  } // If is an array, walk each and return true if any 
  // return true


  if (Array.isArray(matches)) {
    for (let n = 0; n < matches.length; n++) {
      if (isMatch(cxt, matches[n])) {
        return true;
      }
    }

    return false;
  } // If its a function, ask it 


  if (typeof matches === 'function') {
    return matches(cxt);
  } // If its an object, compare keys


  if (typeof matches === 'object') {
    const keys = Object.keys(matches);

    for (let n = 0; n < keys.length; n++) {
      const k = keys[n];
      const v = matches[k];
      const cv = cxt[k] == null ? null : cxt[k];

      if (!doesValueMatch(v, cv, cxt)) {
        return false;
      }
    }

    return true;
  } // huh..wrong type


  return false;
} // key : <string> | [ <string1>, <orString2>, ... ]


exports.isMatch = isMatch;